import Timer from "../../Timer/Timer";
import React, {useContext} from "react";
import {Context} from "../../../index";
import {observer} from "mobx-react-lite";

function InfTour(props){
    const {store} = useContext(Context)
    const data_texts = store.dataLang
    return (
        <div className="tournament_block">
            <div className="tournament">
                <h1>{data_texts["name_every_day_tour"]}<span>1450 B</span></h1>

                <Timer store={store} isReg={props.checkTourReg} initialTimeReg={props.initialTimeReg}
                       initialTime={props.initialTime}/>

            </div>
        </div>
    )
}
export default observer(InfTour)